/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import {
  type ApiImageBackground,
  ApiImageBackgroundSchema,
  type ApiMonochromeBackground,
  ApiMonochromeBackgroundSchema,
} from './background'
import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import {
  type RelatedLinkApiProps,
  RelatedLinkApiPropsSchema,
} from './related-links-content'
import type { RichText } from './rich-text'

/* TypeScript */
export type SectionBannerBackgroundApiProps = {
  sectionBannerImageBackground?: Maybe<ApiImageBackground>
  sectionBannerMonochromeBackground?: Maybe<ApiMonochromeBackground>
}

export type SectionBannerApiProps = {
  title?: Maybe<string>
  titleV2?: Maybe<RichText>
  technicalName?: Maybe<string>
  description?: Maybe<string>
  descriptionV2?: Maybe<RichText>
  button?: Maybe<CmsButtonApiProps>
  relatedLinks?: Maybe<RelatedLinkApiProps>
  additionalSpacing?: Maybe<'Top' | 'Bottom' | 'Top-Bottom' | 'None'>
} & SectionBannerBackgroundApiProps

/* Schemas */
export const SectionBannerBackgroundApiPropsSchema = z.object({
  sectionBannerImageBackground: z.nullish(ApiImageBackgroundSchema),
  sectionBannerMonochromeBackground: z.nullish(ApiMonochromeBackgroundSchema),
})

export const SectionBannerApiPropsSchema = z.intersection(
  z.object({
    title: z.nullish(z.string()),
    titleV2: z.nullish(LooseRichTextSchema),
    technicalName: z.nullish(z.string()),
    description: z.nullish(z.string()),
    descriptionV2: z.nullish(LooseRichTextSchema),
    button: z.nullish(CmsButtonApiPropsSchema),
    relatedLinks: z.nullish(RelatedLinkApiPropsSchema),
    additionalSpacing: z.nullish(
      z.enum(['Top', 'Bottom', 'Top-Bottom', 'None']),
    ),
  }),
  SectionBannerBackgroundApiPropsSchema,
)

/* Schemas validation */
type TestSectionBannerApiProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<SectionBannerApiProps>,
    z.infer<typeof SectionBannerApiPropsSchema>
  >
>
